export default class AnchorLink {
	constructor(linkEl) {
		if (!linkEl) return;

		this.linkEl = linkEl;

		this.init();
		this.events();
	}

	init() {
		this.anchor = this.linkEl.getAttribute("href").substring(1);
	}

	events() {
		if (this.anchor.length > 0) {
			this.linkEl.addEventListener("click", (ev) => {
				ev.preventDefault();
				const targetEl = document.getElementById(this.anchor);
				if (targetEl) {
					targetEl.scrollIntoView({ behavior: "smooth" });
				}
			});
		}
	}
}
